import { storeData } from "../../store";
import utility from "../Dashboard/utility";

// Get ID
export const _getPrimeCategoryId = (name) => {
    for (const el of storeData.primeCategories) {
        if (el.name.trim() === name.trim()) {
            return el.id;
        }
    }
    return "";
};
export const _getCategoryId = (name) => {
    for (const el of storeData.categories) {
        if (el.name.trim() === name.trim()) {
            return el.id;
        }
    }
    return "";
};
export const _getSubCategoryId = (name) => {
    for (const el of storeData.subCategories) {
        if (el.name.trim() === name.trim()) {
            return el.id;
        }
    }
    return "";
};

export const _getVendorId = (vendor_name) => {
    for (const el of storeData.vendorDataList) {
        if (el.vendor_name.trim() === vendor_name.trim) {
            return el.id;
        }
    }
    return "";
};

// Get Name
export const _getPrimeCategoryName = (id) => {
    for (const el of storeData.primeCategories) {
        if (el.id == id) return el.name;
    }
    return null;
};
export const _getCategoryName = (id) => {
    for (const el of storeData.categories) {
        if (el.id == id) return el.name;
    }
    return null;
};
export const _getSubCategoryName = (id) => {
    for (const el of storeData.subCategories) {
        if (el.id == id) return el.name;
    }
    return null;
};
export const _getVendorName = (id) => {
    for (const el of storeData.vendorDataList) {
        if (el.id == id) return el.vendor_name;
    }
    return null;
};

export const getMoneyFormat = (number) => {
    const val = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    }).format(number);
    let num = "";
    for (const el of val) {
        if (el == ".") break;
        num += el;
    }
    return num;
};

const parseAmountToInt = (amountString) => {
    if (amountString) {
        let amountInt = amountString?.replaceAll("$", "");
        amountInt = amountInt.replaceAll(",", "");
        return parseInt(amountInt) || 0;
    } else {
        return null;
    }
};

const parseAmountToNumber = (amountString) => {
    if (amountString) {
        let amountInt = amountString?.replaceAll("$", "");
        amountInt = amountInt.replaceAll(",", "");
        return Number(amountInt) || 0;
    } else {
        return null;
    }
};

const removeDecimals = (val) => {
    let num = "";
    if (val) {
        for (const el of val) {
            if (el == ".") break;
            num += el;
        }
    }
    return num;
};

const sortByMonth = (arr) => {
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const sorter = (a, b) => {
        if (a !== b) {
            return a - b;
        } else {
            return months.indexOf(a.month) - months.indexOf(b.month);
        }
    };
    arr.sort(sorter);
};

const countSecondaryCategories = (primeId) => {
    let count = 0;
    for (const el of storeData.categories) {
        if (el.prime_category == primeId) {
            count++;
        }
    }
    return count;
};

const countSubCategories = (secId) => {
    let count = 0;
    for (const el of storeData.subCategories) {
        if (el.category == secId) {
            count++;
        }
    }
    return count;
};

const getCurrentDate = () => {
    const now = new Date();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    let year = now.getFullYear();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    return `${year}-${month}-${day}`;
};

const getTimestamp = () => {
    return `${getDate()} ${getTime()}`;
};

const getUTCTimestamp = () => {
    return `${getUTCDate()} ${getUTCTime()}`;
};
const getUTCDate = () => {
    const now = new Date();
    let day = now.getUTCDate();
    let month = now.getUTCMonth() + 1;

    if (day < 10) day = `0${day}`;
    if (month < 10) month = `0${month}`;

    return `${now.getUTCFullYear()}-${month}-${day}`;
};

const getUTCTime = () => {
    const now = new Date();
    let min = now.getUTCMinutes();
    let sec = now.getUTCSeconds();
    let hour = now.getUTCHours();

    if (min < 10) min = `0${min}`;
    if (sec < 10) sec = `0${sec}`;
    if (hour < 10) hour = `0${hour}`;

    return `${hour}:${min}:${sec}`;
};

const getDate = () => {
    const now = new Date();
    let day = now.getDate();
    let month = now.getMonth() + 1;

    if (day < 10) day = `0${day}`;
    if (month < 10) month = `0${month}`;
    return `${now.getFullYear()}-${month}-${day}`;
};

const getTime = () => {
    const now = new Date();
    let min = now.getMinutes();
    let sec = now.getSeconds();
    let hour = now.getHours();

    if (min < 10) min = `0${min}`;
    if (sec < 10) sec = `0${sec}`;
    if (hour < 10) hour = `0${hour}`;

    return `${hour}:${min}:${sec}`;
};

const getFormattedDate = (date) => {
    const now = new Date(date);

    let day = now.getUTCDate();
    let month = now.getUTCMonth() + 1;

    if (day < 10) day = `0${day}`;
    if (month < 10) month = `0${month}`;

    return `${now.getUTCFullYear()}-${month}-${day}`;
};

export default {
    _getCategoryId,
    _getCategoryName,
    _getPrimeCategoryId,
    _getPrimeCategoryName,
    _getSubCategoryId,
    _getSubCategoryName,
    _getVendorId,
    _getVendorName,
    getMoneyFormat,
    parseAmountToInt,
    removeDecimals,
    sortByMonth,
    countSecondaryCategories,
    countSubCategories,
    getCurrentDate,
    getTimestamp,
    parseAmountToNumber,
    getFormattedDate,
    getUTCTimestamp,
};
